export default __webpack_public_path__ + "static/media/cp_geo_fr.193fbc05.svg";